import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ children }) => (
  <div className="-wa-modal__header">
    {children}
  </div>
);

Header.propTypes = {
  children: PropTypes.node.isRequired
};

Header.displayName = 'Header';

export default Header;